import type { SVGProps } from 'react';

const ShareFacebook = (props: SVGProps<SVGSVGElement>) => (
  <svg fill='none' height={52} width={52} xmlns='http://www.w3.org/2000/svg' {...props}>
    <rect fill='#1877F2' height={52} rx={12} width={52} />
    <path
      d='m32.929 27.748.826-5.389h-5.17v-3.495c0-1.474.722-2.913 3.038-2.913h2.35v-4.587S31.84 11 29.802 11c-4.258 0-7.041 2.58-7.041 7.252v4.107h-4.733v5.389h4.733v13.025a18.84 18.84 0 0 0 5.825 0V27.748h4.344Z'
      fill='#fff'
    />
  </svg>
);
export default ShareFacebook;
